import axios from 'axios';
import qs from 'qs';
import get from 'lodash/get';
import Vue from 'vue';
import { SET_AUTH_STATE } from '../store/mutation-types';

export function setupAjax(store, router, i18n) {
  if (process.env.NODE_ENV !== 'production') {
    axios.defaults.baseURL = process.env.VUE_APP_DEV_API || 'http://localhost:3000';
  } else {
    axios.defaults.baseURL = `${window.location.origin + window.location.pathname}ui`;
  }

  axios.defaults.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' });

  axios.interceptors.request.use(function (config) {
    config.headers.common['UI-REQUEST-ID'] =
      `f${(+new Date()).toString(16)}` +
      `f${(~~(Math.random() * 1e8)).toString(16)}`;
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (!error.response && error.message && error.message === 'Network Error') {
      Vue.prototype.$notifyEx.error({
        title: i18n.t('error.network-connection.title'),
        message: i18n.t('error.network-connection.message'),
        duration: 25000
      });

      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      store.commit(SET_AUTH_STATE, false);
      router.push('/login');
    } else if (!error.response ||
      error.response.status === 403 ||
      error.response.status === 423 ||
      error.response.status === 404 ||
      error.response.status === 409 ||
      error.response.status === 422 ||
      error.response.status === 423) {
      return Promise.reject(error);
    } else {
      // const method = get(error, 'response.config.method', '');
      // const url = get(error, 'response.config.url', '');
      // const message = get(error, 'response.data.reason', error.toString());
      // const text = get(error, 'response.data.text', '');
      // console.log('request error:', error.response);

      const requestId = get(error, 'response.config.headers.UI-REQUEST-ID', '');
      const host = window.location.host;
      const time = new Date().toISOString();
      const timeFmt = time.substring(5, time.length - 5);

      Vue.prototype.$notifyEx.error({
        title: i18n.t('error.internal-server-error.title'),
        message: i18n.t('error.internal-server-error.message'),
        requestId: `${requestId} ${timeFmt} ${host}`,
        copyButtonName: i18n.t('error.internal-server-error.copy.button'),
        duration: 25000
      });
    }
    return Promise.reject(error);
  });
}
